import React from "preact/compat";
import {CartDropdownProps} from "@/elements-react/cart-control-dropdown";
import styles from "@/elements-react/cart-control-dropdown/css/cart-dropdown.black-and-blue.module.scss";
import FixDropdownHead from "@/elements-react/fix-dropdown-head";
import FixIconIndicator from "@/elements-react/fix-icon-indicator";
import classNames from "classnames";

export const CartDropdownBlackAndBlue:React.FC<CartDropdownProps> = ({count, label, toCart, hideTotal, labelClassName}: CartDropdownProps) => {
    return (
        <div className={classNames(styles.host, labelClassName)}>
            <FixDropdownHead hideIcon={true} className={classNames(styles['cart-dropdown'], {[styles['no-label']] : hideTotal})} labelClassName={classNames({[styles['hidden-label']] : hideTotal})} icon="custom" label={label} onClick={toCart}>
                <FixIconIndicator slot="prefix" count={count} className={styles['cart-dropdown-indicator']} />
            </FixDropdownHead>
        </div>
    );
};